// extracted by mini-css-extract-plugin
export default {"root":"avatar_root__jXq0N","placeholder":"avatar_placeholder__+2h-t","skeleton":"avatar_skeleton__N7zQC"};